import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { SalesCallsTab } from '../components/SalesCallsTab';
import { LeadsTab } from '../components/LeadsTab';
import { Megaphone, Handshake, UserPlus } from '@phosphor-icons/react';

export default function MarketingPage() {
  const { user } = useAuth();

  if (!['supervisor', 'admin', 'director', 'super_admin'].includes(user?.role)) {
    return (
      <div className="flex flex-col items-center justify-center h-64">
        <Megaphone weight="duotone" className="w-16 h-16 text-muted-foreground/50 mb-4" />
        <h3 className="font-heading text-lg">Access Restricted</h3>
      </div>
    );
  }

  return (
    <div className="space-y-6 fade-in" data-testid="marketing-page">
      <div>
        <h1 className="font-heading text-2xl md:text-3xl font-semibold flex items-center gap-3">
          <Megaphone weight="duotone" className="w-8 h-8 text-primary" /> Marketing
        </h1>
        <p className="text-muted-foreground text-sm mt-1">Track sales calls and manage potential client leads</p>
      </div>

      <Tabs defaultValue="sales-calls" className="space-y-4">
        <TabsList className="rounded-xl">
          <TabsTrigger value="sales-calls" className="rounded-lg" data-testid="tab-sales-calls">
            <Handshake weight="duotone" className="w-4 h-4 mr-1" /> Sales Calls
          </TabsTrigger>
          <TabsTrigger value="leads" className="rounded-lg" data-testid="tab-leads">
            <UserPlus weight="duotone" className="w-4 h-4 mr-1" /> Leads
          </TabsTrigger>
        </TabsList>

        <TabsContent value="sales-calls">
          <SalesCallsTab />
        </TabsContent>

        <TabsContent value="leads">
          <LeadsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
